/**
 * ╔═══════════════════════════════════════════════════════════════════════════╗
 * ║  BETAWARNINGBANNER.TSX - Beta Mode Warning                                ║
 * ║  Shows a persistent warning when running in beta mode                     ║
 * ╚═══════════════════════════════════════════════════════════════════════════╝
 */

import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const IS_BETA = import.meta.env.VITE_BETA_MODE === 'true';

export function BetaWarningBanner() {
  const [dismissed, setDismissed] = useState(false);

  if (!IS_BETA || dismissed) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -60, opacity: 0 }}
        className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-orange-600 via-yellow-500 to-orange-600 text-black px-4 py-2"
      >
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <div className="flex items-center gap-3">
            <span className="text-2xl">⚠️</span>
            <div>
              <span className="font-bold font-orbitron">BETA TEST</span>
              <span className="ml-2 font-rajdhani">
                This is a test deployment. Game state will reset at official launch. Use small amounts only!
              </span>
            </div>
          </div>
          <button
            onClick={() => setDismissed(true)}
            className="px-3 py-1 bg-black/20 hover:bg-black/30 rounded-lg transition-colors font-mono text-sm"
          >
            ✕ Dismiss
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}

export default BetaWarningBanner;
